var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C18.299 22 23 17.5228 23 12C23 6.47715 18.299 2 12.5 2C6.70101 2 2 6.47715 2 12C2 17.5228 6.70101 22 12.5 22Z",
    fill: "url(#paint0_linear_40_233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59922 13.4294C8.37242 13.4294 8.99922 12.7898 8.99922 12.0008C8.99922 11.2119 8.37242 10.5723 7.59922 10.5723C6.82602 10.5723 6.19922 11.2119 6.19922 12.0008C6.19922 12.7898 6.82602 13.4294 7.59922 13.4294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4977 13.4294C13.2709 13.4294 13.8977 12.7898 13.8977 12.0008C13.8977 11.2119 13.2709 10.5723 12.4977 10.5723C11.7245 10.5723 11.0977 11.2119 11.0977 12.0008C11.0977 12.7898 11.7245 13.4294 12.4977 13.4294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 13.4294C18.1732 13.4294 18.8 12.7898 18.8 12.0008C18.8 11.2119 18.1732 10.5723 17.4 10.5723C16.6268 10.5723 16 11.2119 16 12.0008C16 12.7898 16.6268 13.4294 17.4 13.4294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87164 21.599L8.35764 20.6419C8.76364 20.5276 8.90364 20.0133 8.60964 19.699L6.06164 17.099C5.76764 16.799 5.24964 16.9276 5.13764 17.3562L4.19964 20.9133C4.08764 21.3276 4.46564 21.7133 4.87164 21.599Z",
    fill: "url(#paint1_linear_40_233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_233",
    x1: 2,
    y1: 12,
    x2: 23,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_233",
    x1: 4.17969,
    y1: 19.2775,
    x2: 8.76628,
    y2: 19.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentW);
export default __webpack_public_path__ + "static/media/comment-w.8d7977357fcbd23b21e8ee395d2a8cd6.svg";
export { ForwardRef as ReactComponent };